import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { useDialogStore } from '@/stores/dialogs';
import { useKeyDownStore } from '@/stores/key-down';
import VBackdrop from '../VBackdrop.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheDialogBase',
  setup(__props) {

const dialogStore = useDialogStore()

useKeyDownStore().watch("Escape", () => !!dialogStore.dialog, dialogStore.close)


return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(VBackdrop, {
    show: !!_unref(dialogStore).dialog,
    onClose: _unref(dialogStore).close
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "dialog rounded bd-scale scroll" }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(dialogStore).dialog), _normalizeProps(_guardReactiveProps(_unref(dialogStore).dialogProps)), null, 16))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show", "onClose"]))
}
}

})